import { ICacheExcludedEndpoint } from "../../../Orchestrator/Types/Types/EndpointTypes";
import { getRuntimeConfig } from "../RuntimeConfig";

export async function getEndpoints() {
  let config: any;
  if (typeof window !== "undefined") {
    config = await getRuntimeConfig();
  } else {
    config = process.env;
  }
  return {
    getStops: `${config.NEXT_PUBLIC_API_RETAILER}/stops`,
    getCmsStops: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/stops`,
    getEnhanceYourTripAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/enhance-trips`,
    getPopularTripsAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/popular-trips`,
    getFaqsList: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/faq-categories`,
    getDestinationsAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/cities`,
    getFamousPlacesAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/famous-places`,
    getCMSOffersAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/offers`,
    getCmsServiceClassesAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/service-classes`,
    getCmsProductsAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/products`,
    getTermsofUse: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/terms-of-use-document`,
    getPrivacyPolicy: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/privacy-policy`,
    getRoutesAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/routes`,
    getAppDownloadLinkAndQrAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/app-download-link`,
    getAboutLoyaltyProgramAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/about-loyalty-program`,
    getTrustBuilderAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/trust-builders`,
    getCmsNewsAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/news-articles`,
    getCmsHomeBannerAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/home-banners`,
    getCmsAccountBannerAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/account-banner`,
    getUsefulInformationAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/helps-and-useful-information`,
    getNetworkMapStations: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/stations`,
    getNetworkMapStationInfo: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/network-map-station`,
    getConfirmationContentAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/content-policies`,
    getCmsMonthlyPassOffersAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/monthly-pass-offers`,
    getCmsTravelPassOffersAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/travel-pass-offers`,
    getCmsSpecialFareOffersAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/special-fare-offers`,
    getCmsAboutMonthlyPassAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/about-monthly-pass`,
    getCmsAboutTravelPassAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/about-travel-pass`,
    getCmsGroupBookingAPI: `${config.NEXT_PUBLIC_CMS_API_ENDPOINT}/group-booking`,
    getOffers: `${config.NEXT_PUBLIC_API_RETAILER}/offers`,
    getPassOffersAPI: `${config.NEXT_PUBLIC_API_RETAILER}/offers`,
    getMultiTripBookingOffersAPI: `${config.NEXT_PUBLIC_API_RETAILER}/offers/multi-bookings`,
    getLanguage: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/preferred-languages`,
    updateCustomerById: `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/`,
    getSpecialAssistancePref: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/special-assistance-preferences`,
    getMealPreference: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/meal-preferences`,
    getUserDetails: `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/me`,
    // getTrainSchedule: (date: string, from: string = '', to: string = '', limit: number = 200, offset: number = 0) => `${config.NEXT_PUBLIC_API_TRANSCITY_CPA}/journey/trains/schedule,
    getTrainSchedule: (date: string, from: string = '', to: string = '', limit: number = 9999, offset: number = 0, arrivalFromTime: string = '') =>
      `/api/train-schedule?date=${encodeURIComponent(date)}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&limit=${limit}&offset=${offset}${arrivalFromTime ? `&arrival_from_time=${encodeURIComponent(arrivalFromTime)}` : ''}`,
    getLoyaltyProgram: (userId: number) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/loyalty-program`,
    getCustomerTiers: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/tiers`,
    getTiersConfig: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/tiers-config`,
    getCountryCodes: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/country-codes`,
    getPassengerType: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/passenger-types`,
    getTicketOptions: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/ticket-options`,
    getSeatingPreferences: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/seating-preferences`,
    getCountries: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/country-codes`,
    getServiceRequestCategories: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/tickets/service-request-categories`,
    postBooking: `${config.NEXT_PUBLIC_API_RETAILER}/bookings`,
    patchPassenger: `${config.NEXT_PUBLIC_API_RETAILER}/bookings`,
    patchPurchaser: `${config.NEXT_PUBLIC_API_RETAILER}/bookings`,
    postFulfillment: `${config.NEXT_PUBLIC_API_RETAILER}/bookings`,
    getBooking: `${config.NEXT_PUBLIC_API_RETAILER}/bookings`,
    getBookingPassenger: (bookingId: string, passengerId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/passengers/${passengerId}`,
    getTravelAccounts: `${config.NEXT_PUBLIC_API_RETAILER}/travel-accounts`,
    cancelPreBookingAPI: (bookingId: string) => `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}`,
    extendBookingValidUntil: (bookingId: string) => `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/valid-until`,
    bookingsSearchCustom: `${config.NEXT_PUBLIC_API_RETAILER}/bookings-search/custom`,
    bookingUpgradeToPremium: `${config.NEXT_PUBLIC_API_RETAILER}/bookings`,
    placeMapAvailability: `${config.NEXT_PUBLIC_API_RETAILER}/availabilities/place-map`,
    coachLayout: `${config.NEXT_PUBLIC_API_RETAILER}/coach-layouts`,
    floorPlanIcons: `${config.NEXT_PUBLIC_API_RETAILER}/floor-plan-icons`,
    getUIpreferences: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/ui-preferences`,
    getContactCategories: `${config.NEXT_PUBLIC_API_TRANSCITY}/metadata/customers/contact-us-config`,
    postContactForm: `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/contact-us`,
    bookingsReleaseOffers: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/release-offers`,
    bookingsReleaseOffersPatch: (releaseId: string, bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/release-offers/${releaseId}`,
    bookingsRefundOffers: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/refund-offers`,
    bookingsRefundOffersPatch: (releaseId: string, bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/refund-offers/${releaseId}`,
    bookingsCancelPaymentPost: (bookingId: string) =>
      `/api/payment/refund/${bookingId}`,
    getAdditionalOffers: (bookingId: string, bookingOfferId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/booked-offers/${bookingOfferId}/additional-offers`,
    saveAncillaryToOffer: (bookingId: string, bookingOfferId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/booked-offers/${bookingOfferId}/ancillaries`,
    deleteAncillaryFromOffer: (bookingId: string, bookingOfferId: string, ancillaryId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/booked-offers/${bookingOfferId}/ancillaries/${ancillaryId}`,
    bookingsExchangeOffers: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/exchange-offers?embed=ALL`,
    preExchangeOperationStart: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/exchange-operations`,
    externalPaymentAPI: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/external-payment`,
    zeroPaymentAPI: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/zero-payment`,
    savePersonalizeExperience: (userId: number) =>
      `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}`,
    manageWidgetAPI: `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/app-data`,
    getApiConfigAPI: `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/app-data/cache/web`,
    cancelExchangeOffers: (bookingId: string, exchangeOperationId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/exchange-operations/${exchangeOperationId}`,
    addBookOfferToBookingAPI: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/booked-offers`,
    deleteBookOfferToBookingAPI: (bookingId: string, offerId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/booked-offers/${offerId}`,
    getReplacementOffersAPI: (bookingId: string, offerId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/booked-offers/${offerId}/replacement-offers`,
    replaceBookedOfferAPI: (bookingId: string, offerId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/booked-offers/${offerId}/replace`,
    saveServiceRequestAPI: `${config.NEXT_PUBLIC_API_TRANSCITY}/tickets`,
    fetchVouchersAPI: (userId: number) =>
      `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/vouchers`,
    fetchVoucherDetailsAPI: (userId: number, voucherId: number) =>
      `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/vouchers/${voucherId}`,
    addVoucherAPI: (userId: number) =>
      `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/vouchers`,
    validateVoucherAPI: (bookingId: string, voucherCode: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/vouchers/${voucherCode}/validate`,
    markForVoucherPaymentAPI: (bookingId: string, voucherCode: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/vouchers/${voucherCode}/mark-for-payment`,
    removeVoucherAPI: (bookingId: string, voucherCode: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/vouchers/${voucherCode}/mark-for-payment`,
    payWithVoucherAPI: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/pay/with/voucher`,
    bookingUpgradeToPremiumAPI: (bookingId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/exchange-offers/upgrades`,
    patchBooking: `${config.NEXT_PUBLIC_API_RETAILER}/bookings`,
    bestPrice: `${config.NEXT_PUBLIC_API_RETAILER}/price-calendar/best-prices`,
    favouriteDeparturesBestPrices: `${config.NEXT_PUBLIC_API_PAYMENT}/best-prices`,
    // FLM ride hailing estimates proxy (best-prices API base). Uber body is relayed unchanged.
    rideHailingEstimates: `${config.NEXT_PUBLIC_API_PAYMENT}/flm/ride-hailing/estimates`,
    // Uber handoff URL. beef builds it (Singular campaign link, double-encoded,
    // template revised twice) — the client MUST NOT construct this locally.
    rideHailingDeeplink: `${config.NEXT_PUBLIC_API_PAYMENT}/flm/ride-hailing/deeplink`,
    carRentalLocations: `${config.NEXT_PUBLIC_API_PAYMENT}/flm/car-rental/locations`,
    carRentalRateCardV2: `${config.NEXT_PUBLIC_API_PAYMENT}/flm/car-rental/rate-card`,
    carRentalResolveSearch: `${config.NEXT_PUBLIC_API_PAYMENT}/flm/car-rental/resolve-search`,
    carRentalRateSummary: `${config.NEXT_PUBLIC_API_PAYMENT}/flm/car-rental/rate-summary`,
    carRentalEntryLink: `${config.NEXT_PUBLIC_API_PAYMENT}/flm/car-rental/entry-link`,
    fmlmSearchLocation: `${config.NEXT_PUBLIC_GEOCODE_API}`,
    getPlaces: `${config.NEXT_PUBLIC_API_RETAILER}/places/all`,
    fmlmReverseGeocode: `/api/mapbox/search/geocode/v6/reverse`,
    fmlmCalculateDistance: `/api/mapbox/directions-matrix/v1/mapbox/driving`,
    fmlmViewInformation: config.NEXT_PUBLIC_AXONVIBE_JOURNEY_API,
    phoneVerifications: (userId: number) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/verifications/phone`,
    phoneValidate: (userId: number) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/verifications/phone/validate`,
    changePassword: (userId: string) => `${config.NEXT_PUBLIC_API_TRANSCITY}/accounts/${userId}/password?realm=${config.NEXT_PUBLIC_KEYCLOAK_REALM}`,
    deleteAccount: (userId: number) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}`,
    getServiceRequestTicketList: `${config.NEXT_PUBLIC_API_TRANSCITY}/tickets`,
    addCommentToTicket: (ticketId: number) => `${config.NEXT_PUBLIC_API_TRANSCITY}/tickets/${ticketId}/events`,
    closeTicket: (ticketId: number) => `${config.NEXT_PUBLIC_API_TRANSCITY}/tickets/${ticketId}/events`,
    postRequestCorporateAccount: `${config.NEXT_PUBLIC_API_TRANSCITY}/corporates`,
    customerLogout: (redirectUri: string, idTokenHint: string) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/logout?post_logout_redirect_uri=${redirectUri}&id_token_hint=${idTokenHint}`,
    requestInvoiceRMS: `${config.NEXT_PUBLIC_API_RMS}/api/invoice`,
    refundAncillaryFromOffer: (bookingId: string) =>
      `/api/payment/refund/${bookingId}`,
    patchRefundAncillaryFromOffer: (bookingId: string, refundOfferId: string) =>
      `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/refund-offers/${refundOfferId}`,
    getBookingComment: (booking_id: string) => `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${booking_id}/comments`,
    createBookingComment: (booking_id: string) => `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${booking_id}/comments`,
    updateBookingComment: (booking_id: string, comment_id: string) => `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${booking_id}/comments/${comment_id}`,
    getBookingPaymentData: (bookingId: string) => `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${bookingId}/payments`,
    getPaymentCards: (userId: string) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/payment-cards`,
    deletePaymentCards: (userId: string, paymentCardId: string) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/payment-cards/${paymentCardId}`,
    setDefaultPaymentCard: (userId: string, paymentCardId: string) => `${config.NEXT_PUBLIC_API_TRANSCITY}/customers/${userId}/payment-cards/${paymentCardId}/default`,
    cancelPlaceSelection: (booking_id: string) => `${config.NEXT_PUBLIC_API_RETAILER}/bookings/${booking_id}/place-selections/cancel`
  } as const;
}

// Endpoints that must ALWAYS hit the network. This list wins over both the
// backend apiConfig rules and the blanket CMS caching rule, so it is the single
// place to force freshness without waiting on a config change.
export const cacheExcludedEndpoints: ICacheExcludedEndpoint[] = [{
  endpoint: "/transcity-int/customers/me",
  methods: ['GET']
}, {
  // CMS offers (getCmsOffers / getCmsOfferDetail) — promotional content is
  // published and pulled at short notice, so a 1h cache shows expired offers.
  endpoint: "/api/offers",
  methods: ['GET']
}, {
  // Fare calendar — prices move with inventory; a cached grid quotes a price
  // the offers call then refuses.
  endpoint: "/price-calendar/best-prices",
  methods: ['POST']
}, {
  // Stored cards — the list is re-read straight after a delete or a change of
  // default card, so a cached copy would show the old default and preselect it
  // at checkout.
  endpoint: "/payment-cards",
  methods: ['GET']
}]
